import { Form } from 'react-bootstrap';

import { EditNodeDefinitionPathReference } from 'edit/reference/EditNodeDefinitionPathReference';

const FlowProperties = ({ state, onChange }: any) => {
  const { config } = state;

  return (
    <>
      <Form.Group className="mb-2" controlId="formOnError">
        <Form.Label>On Error</Form.Label>
        <Form.Select as="select" name="on_error" value={config?.on_error || ''} onChange={(e) => onChange(e, true)}>
          <option value="">Default (Raise Workflow and Wait)</option>
          <option value="raise_workflow_and_wait">Raise Workflow and Wait</option>
          <option value="abort">Abort</option>
        </Form.Select>
        <Form.Text className="text-muted">Abort skips the operator message and fails the parent flow when the failed handle has no outgoing edge.</Form.Text>
      </Form.Group>

      <Form.Group className="mb-2" controlId="formOnKilled">
        <Form.Label>On Killed</Form.Label>
        <Form.Select as="select" name="on_killed" value={config?.on_killed || ''} onChange={(e) => onChange(e, true)}>
          <option value="">Default (Raise Workflow and Wait)</option>
          <option value="raise_workflow_and_wait">Raise Workflow and Wait</option>
          <option value="abort">Abort</option>
        </Form.Select>
        <Form.Text className="text-muted">
          When a child is killed, a killed handle on that child is used, including its edge and status action. With no killed handle, the kill uses the failed
          handle: an edge on it is followed, and a status action on it runs only when the child fails. When the chosen handle has no outgoing edge, the default
          raises an operator message on that handle. Abort skips the operator message and fails the parent flow when that handle has no outgoing edge.
        </Form.Text>
      </Form.Group>

      {(config?.on_error === 'raise_workflow_and_wait' || config?.on_killed === 'raise_workflow_and_wait') && (
        <Form.Group className="mb-2" controlId="formWorkflowDefinition">
          <Form.Label>Workflow Node Definition</Form.Label>
          <EditNodeDefinitionPathReference
            placeholder="Search and select a workflow definition..."
            value={config?.workflow_node_definition ?? null}
            // The config field is a `zone|name` path, and the backend resolves it to an id on save.
            // Cleared reads as '' rather than null: the bridge writes whatever it is given straight
            // into config, and the rest of this editor treats a missing value as the empty string.
            onChange={(path) => onChange({ target: { name: 'workflow_node_definition', value: path ?? '' } }, true)}
            type="workflowActionCreate"
          />
        </Form.Group>
      )}
    </>
  );
};

export default FlowProperties;
